import {HttpClient} from '@angular/common/http';
import {API_URL} from '../constants';

/**
 * A browser session can outlive a release: someone signed in yesterday has the token but not a value the new
 * release stores at login (such as `roleScope`), and would be shown the most restricted view until they sign out
 * and in. This runs once at start-up and, for a signed-in session that is missing it, asks the server who the caller
 * is and fills it in. It never blocks start-up: any failure just leaves things as they were.
 */
export function backfillSession(http: Pick<HttpClient, 'get'>): () => Promise<void> {
    return () => new Promise<void>((resolve) => {
        try {
            const signedIn = !!sessionStorage.getItem('username') && !!sessionStorage.getItem('access_token');
            if (!signedIn || sessionStorage.getItem('roleScope')) {
                resolve();
                return;
            }
            http.get<{ roles?: string; roleScope?: string; rolesPermission?: unknown }>(`${API_URL}auth/me`).subscribe({
                next: (me) => {
                    try {
                        if (me?.roleScope) sessionStorage.setItem('roleScope', me.roleScope);
                        if (me?.roles) sessionStorage.setItem('userGroup', me.roles);
                        if (me?.rolesPermission) sessionStorage.setItem('rolesPermission', JSON.stringify(me.rolesPermission));
                    } finally {
                        resolve();
                    }
                },
                error: () => resolve()
            });
        } catch {
            resolve();
        }
    });
}
